/* @flow */
import { capitalize } from 'lodash';
import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import User from 'entities/User';
import UserAvatar from 'users/components/UserAvatar.jsx';

type Props = {
  avatar?: React.Element,
  subtext?: string,
  user: User,
};

export default function UserAvatarWithText({ avatar, subtext, user, ...others }: Props) {
  return (
    <AvatarWithText
      {...others}
      title={user.getSignature() || user.getName()}
      avatar={avatar || <UserAvatar user={user.toJSON()} />}
      subtext={subtext || capitalize(user.getRole())}
    />
  );
}
